import * as components from './components'
import { F, platform, time } from './utils'
import { $L, L } from './store'
import cfg from '../config'
import { TabList } from './components/LMain/LRouterTabs/RouterTab'
import VueRouter from 'vue-router'

const LAdmin = {}

LAdmin.install = function (Vue, opts) {
  let o = {
    F,
    opts,
    cfg,
    platform,
    time
  }
  if (opts.store instanceof Object && opts.store.registerModule) {
    opts.store.registerModule('$L', $L)
    o.alert = function (type, config) {
      if (opts.store) {
        let cfg
        let t = type
        if (type instanceof Object) {
          cfg = type
          t = type.type || 'error'
        } else if (config instanceof Object) {
          cfg = config
        } else {
          cfg = { message: config }
        }
        return opts.store.dispatch('L/alert', { type: t || cfg.type || 'error', ...cfg })
      }
    }
    o.error = function (...args) {
      return this.alert('error', ...args)
    }
    o.success = function (...args) {
      return this.alert('success', ...args)
    }
    o.confirm = function (config) {
      if (opts.store) {
        return opts.store.dispatch('L/confirm', config)
      }
    }
  } else {
    throw new Error('请在LAdmin插件的options中注入store')
  }
  if (opts.router instanceof VueRouter) {
    const tab = Vue.observable(new TabList(opts.router))
    o.tab = tab
    // 让L能使用tab API
    opts.store.registerModule('L', Object.assign({}, L, {
      modules: {
        tab: {
          namespaced: true,
          actions: {
            get (...args) {
              return tab.get(...args)
            },
            set (...args) {
              return tab.set(...args)
            },
            indexOf (...args) {
              return tab.indexOf(...args)
            },
            clear (...args) {
              return tab.clearAll(...args)
            },
            clearAll (...args) {
              return tab.clearAll(...args)
            },
            push (...args) {
              return tab.push(...args)
            },
            replace (...args) {
              return tab.replace(...args)
            },
            move (...args) {
              return tab.move(...args)
            }
          }
        }
      }
    }))
  } else {
    throw new Error('请在LAdmin插件的options中注入router')
  }
  for (let key of Object.keys(components)) {
    Vue.component(key, components[key])
  }

  Vue.prototype.$L = o
}
export default LAdmin
export * from './components'
export { F, time, platform }
